var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-bar"},[_c('button',{staticClass:"search-btn flex justify-center items-center text-white w-full",on:{"click":_vm.debounceSearch}},[_c('Icon',{staticClass:"mr-2",attrs:{"name":"search_solid","width":"13","height":"13"}}),_c('span',[_vm._v("検索")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }